export const Ciasta = [

  {
    "id": "mieszanka-3",
    "name": "Uniwersalna Mieszanka Mąk Bezglutenowych",
    "category": "CIASTKA",
    "shortDesc": "Mieszanka mąk bezglutenowych, idealna do zastąpienia mąki pszennej w wypiekach.",
    "fullDesc": "Idealna do wszelkich wypieków, ta mieszanka mąk bezglutenowych łączy w sobie neutralność mąki jaglanej, orzechowy posmak mąki gryczanej oraz zbożowy akcent mąki amarantusowej. Ważne są proporcje, które należy zachować, aby uzyskać właściwości mąk zawierających gluten. Świetnie sprawdza się jako zamiennik mąki pszennej, zachowując odpowiednią konsystencję i sprężystość w wypiekach.",
  
    "preparation": "Na 9 szklanek mieszanki \n(należy zachować proporcje pierwszych sześciu szklanek do pozostałych trzech szklanek mąki ziemniaczanej i tapioki):\n\n6 szklanek mąki (w dowolnej proporcji): jaglanej, gryczanej, z amarantusa (ewentualnie mąka ryżowa lub kukurydziana)\n2 szklanki mąki (w dowolnej proporcji) ziemniaczanej lub z tapioki\n\n\nPrzykład:\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n2 szklanki mąki ziemniaczanej\n1 szklanka mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki ziemniaczanej\n\nLUB najprościej\n6 szklanek mąki jaglanej\n3 szklanki mąki ziemniaczanej\n\nLUB moja ulubiona wersja\n1kg mąki jaglanej\n1kg mąki gryczanej\n1kg mąki z tapioki\n\n Wymieszać razem, najlepiej przesiewając stopniowo przez sito.\n\n\nZdrowego! 🌱✨💚",
    "ingredients": [
        "Proporcje są kluczowe – sprawdź opis przygotowania, aby poznać dokładne ilości:\n",
        "Mąka jaglana",
        "Opcjonalnie: Mąka gryczana (i mąka z amarantusa)",
        "Ewentualnie: Mąka ryżowa lub kukurydziana",
        "Mąki ziemniaczana",
        "Opcjonalnie: Mąka z tapioki"
    ].join("\n"),
    "image": "Ciastka/mieszanka.jpg",
    "path": "ciastka"
},

  

{
  "id": "ciasto-1",
  "name": "Ciasto bananowo-rodzynkowe",
  "category": "CIASTA",
  "shortDesc": "Wilgotne, pełne smaku ciasto bananowe z rodzynkami i zdrowymi dodatkami.",
  "fullDesc": "To ciasto jest odrobinę gumiaste, ale zdecydowanie nadrabia smakiem i wyjątkową wilgotnością. Ma naturalną słodycz dzięki dojrzałym bananom i rodzynkom, a wygląd ma spektakularnie apetyczny. Idealne na zdrowy podwieczorek, pełne błonnika i energii. Przepis pochodzi z książki Deliciously Ella with Friends.",
  "image": "Ciasta/bananowo_rodzynkowe.jpg",
  "preparation": "1. Przygotowanie piekarnika i blaszki:\nNagrzej piekarnik do 180°C (termoobieg). Blaszkę o średnicy 22 cm lub 24 cm wyłóż papierem do pieczenia i posmaruj olejem kokosowym.\n\n2. Zmielenie płatków owsianych:\nZmiel płatki owsiane na mąkę w młynku do kawy lub blenderze.\n\n3. Przygotowanie ciasta:\nObierz banany i rozgnieć je widelcem. Do rozgniecionych bananów dodaj zmielone płatki owsiane, dżem jabłkowy (lub zblendowane świeże jabłka), cynamon, ksylitol, rodzynki i nasiona chia. Wszystko dokładnie wymieszaj, aż uzyskasz jednolitą masę.\n\n4. Pieczenie ciasta:\nPrzełóż masę do przygotowanej blaszki. Piecz w nagrzanym piekarniku przez 50 minut, aż ciasto będzie sprężyste i lekko złociste na wierzchu. Po upieczeniu odstaw ciasto na 30 minut, aby przestygło.\n\n5. Przygotowanie masy kremowej:\nW trakcie pieczenia ciasta przygotuj krem. Zblenduj przejrzałe banany, daktyle, rozpuszczony olej kokosowy, masło migdałowe i cynamon na gładką masę.\n\n6. Dekorowanie ciasta:\nPo przestygnięciu ciasta wyjmij je z blaszki i rozsmaruj przygotowaną masę kremową na górze. Udekoruj chipsami bananowymi i posyp dodatkowym cynamonem.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "Na ciasto:",
    "2 łyżki rozpuszczonego oleju kokosowego do natłuszczenia blaszki",
    "4 przejrzałe banany",
    "300 g płatków owsianych bezglutenowych",
    "360 g dżemu jabłkowego, albo zblendowanych jabłek",
    "2 łyżeczki cynamonu",
    "4 łyżeczki ksylitolu",
    "100 g rodzynek",
    "2 łyżki nasion chia",
    "Na krem:",
    "2 przejrzałe banany",
    "4 daktyle",
    "2 łyżki rozpuszczonego oleju kokosowego",
    "2 łyżki masła migdałowego (lub innego)",
    "½ łyżeczki cynamonu",
    "Garść domowych chipsów bananowych {LINK}, do dekoracji"
  ].join("\n"),
  "path": "ciasta"
},



{
  "id": "ciasto-2",
  "name": "Biszkopt na tort",
  "category": "CIASTA",
  "shortDesc": "Delikatny bezglutenowy na tort",
  "fullDesc": "Ten biszkopt jest puszysty, lekki i delikatny, idealny do przełożenia ulubionym kremem lub owocami. Dzięki użyciu mąki owsianej i ziemniaczanej jest odpowiedni dla osób na diecie bezglutenowej. Przepis sprawdzi się zarówno na prosty tort, jak i jako baza do bardziej wymyślnych wypieków.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika i blaszki:\nRozgrzej piekarnik do 160°C (termoobieg). Blaszkę wyłóż papierem do pieczenia i natłuść olejem.\n\n2. Przygotowanie jajek:\nBiałka oddziel od żółtekUbicie białek:\nBiałka ubij na sztywno ze szczyptą soli himalajskiej. Pod koniec ubijania stopniowo dodawaj cukier.\n\n3. Dodanie żółtek:\nPo ubiciu białek, delikatnie dodaj żółtka, mieszając mikserem na najniższych obrotach.\n\n4. Dodanie mąki:\nPrzesiej mąki przez sito i delikatnie wmieszaj je do masy jajecznej ręcznie, aby zachować puszystość ciasta.\n\n5. Pieczenie biszkopta:\nPrzełóż ciasto do przygotowanej blaszki. Piecz przez 20-25 minut w nagrzanym piekarniku, aż biszkopt będzie lekko złocisty i sprężysty. Studź ciasto w piekarniku, aby nie opadło.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "2 jaja",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "4 łyżki cukru",
    "25 g mąki owsianej bezglutenowej",
    "25 g mąki ziemniaczanej",
    "Olej do blaszki"
  ].join("\n"),
  "path": "ciasta"
},

{
  "id": "ciasto-3",
  "name": "Biszkopt migdałowy",
  "category": "CIASTA",
  "shortDesc": "Delikatny biszkopt migdałowy",
  "fullDesc": "Biszkopt migdałowy to lekka, wilgotna alternatywa dla tradycyjnego ciasta, która nie zawiera mąki. Z dodatkiem cytryny i cynamonu ma wyjątkowy smak, a zmielone migdały sprawiają, że jest bogaty w białko i zdrowe tłuszcze. Idealny do podania z ulubionymi dodatkami, takimi jak lody.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika i tortownicy:\nPosmaruj tortownicę o średnicy 23 cm masłem i oprósz ją zwykłą mąką. Rozgrzej piekarnik do 150°C.\n\n2. Ubicie jajek:\nJajka ubij z cukrem, skórką z cytryny i cynamonem na gęstą, jednolitą masę.\n\n3. Dodanie migdałów:\nDodaj zmielone migdały i delikatnie wymieszaj masę szpatułką lub zmiksuj na minimalnych obrotach miksera.\n\n4. Pieczenie ciasta:\nWylej masę do przygotowanej tortownicy i wstaw do piekarnika. Piecz przez 35-40 minut, aż ciasto będzie suche w dotyku, a patyczek wbity w środek wyjdzie czysty.\n\n5. Studzenie i dekoracja:\nWyjmij ciasto z piekarnika i ostudź. Posyp cukrem pudrem i pokrój na małe kawałki. Podawaj z gałką lodów.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "3 duże jajka",
    "150 g cukru",
    "½ łyżeczki cynamonu",
    "150 g zmielonych obranych migdałów",
    "Cukier puder do posypania"
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-4",
  "name": "Błyskawiczny murzynek z dżemem/powidłami",
  "category": "CIASTA",
  "shortDesc": "Proste, szybkie ciasto czekoladowe z dodatkiem dżemu lub powideł.",
  "fullDesc": "Błyskawiczny murzynek to idealne ciasto dla osób, które szukają czegoś prostego i szybkiego do przygotowania. Z dodatkiem miodu i kakao oraz zaskakująco puszystą konsystencją, jest pysznym wyborem na szybki deser. Dzięki dżemowi lub powidłom, ciasto zyskuje dodatkową wilgotność i wyjątkowy smak.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 200°C (termoobieg).\n\n2. Ubijanie jajek:\nJajka ubij z szczyptą soli mikserem na puszystą masę.\n\n3. Dodanie miodu:\nStopniowo dodawaj miód, wciąż ubijając masę mikserem.\n\n4. Dodanie suchych składników:\nDodaj mąkę, sodę i kakao. Wymieszaj mikserem, aż składniki się połączą.\n\n5. Dodanie oleju:\nStopniowo dodawaj olej, wciąż ubijając ciasto mikserem.\n\n6. Dodanie dżemu/powideł:\nNa koniec dodaj dżem lub powidła i jeszcze raz wymieszaj mikserem.\n\n7. Pieczenie ciasta:\nPrzełóż masę do formy i piecz w nagrzanym piekarniku przez 20-25 minut, aż ciasto będzie sprężyste i suchy patyczek włożony do środka wyjdzie czysty.\n\n8. Dekorowanie ciasta:\nPodawaj posypane cukrem pudrem lub posmarowane pozostałym dżemem i polane czekoladą.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "3 jajka",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "½ szklanki miodu",
    "1 szklanka mąki mieszanki bezglutenowej",
    "½ łyżeczki sody",
    "2 łyżki kakao",
    "⅓ szklanki oleju",
    "4-5 łyżek dżemu lub powideł"
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-5",
  "name": "Ciasto marchewkowe",
  "category": "CIASTA",
  "shortDesc": "Wilgotne, aromatyczne ciasto marchewkowe z dodatkiem cynamonu i płatków migdałowych.",
  "fullDesc": "Ciasto marchewkowe to pyszne i wilgotne ciasto, które łączy w sobie zdrowe składniki, takie jak marchew i cukinia. Słodkie, z nutą cynamonu, udekorowane płatkami migdałowymi, to świetny wybór na każdą okazję. Opcjonalnie można dodać rodzynki dla dodatkowej słodyczy.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 190°C.\n\n2. Przygotowanie warzyw:\nMarchew (i ewentualnie cukinię) obierz ze skórki umyj i zetrzyj na dużych oczkach tarki.\n\n3. Wymieszanie składników:\nW dużej misce wymieszaj mąkę, cukier, olej, jajka, sodę i cynamon na gładką masę.\n\n4. Dodanie warzyw:\nDo ciasta dodaj startą marchew (oraz cukinię, jeśli używasz) oraz ewentualnie rodzynki. Wszystko dokładnie wymieszaj.\n\n5. Udekorowanie ciasta:\nPrzełóż masę do formy i udekoruj płatkami migdałowymi.\n\n6. Pieczenie ciasta:\nPiec przez 60 minut w 190°C na środkowej półce piekarnika, aż ciasto będzie sprężyste, a patyczek wbity w środek wyjdzie czysty.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "500 g marchewki (lub mieszanki marchewki i cukinii)",
    "200 g mąki gryczanej",
    "150 g cukru",
    "¾ szklanki oleju",
    "3 jaja",
    "1 kopiata łyżeczka sody oczyszczonej",
    "1 łyżeczka cynamonu",
    "1-2 garście płatków migdałowych",
    "Opcjonalnie: Rodzynki"
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-6",
  "name": "Kakaowy biszkopt z bananami i czekoladą",
  "category": "CIASTA",
  "shortDesc": "Puszysty biszkopt kakaowy z plasterkami banana i kawałkami gorzkiej czekolady.",
  "fullDesc": "Kakaowy biszkopt z bananami i czekoladą to pyszne i lekkie ciasto, które łączy w sobie naturalną słodycz bananów, intensywny smak gorzkiej czekolady oraz puszystą teksturę biszkoptu. Idealne na zdrowy deser, pełne smaku i aromatu.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie owoców i czekolady:\nBanany obierz ze skórki i pokrój w plasterki, a czekoladę w kosteczkę.\n\n3. Ubijanie białek:\nBiałka ubij na sztywną pianę ze szczyptą soli. Pod koniec ubijania dodaj ksylitol i kontynuuj ubijanie przez chwilę.\n\n4. Dodanie żółtek:\nDodaj żółtka i delikatnie wymieszaj całość trzepaczką.\n\n5. Dodanie suchych składników:\nDodaj mąkę i kakao przesiane przez sito, a następnie bardzo delikatnie wymieszaj całość za pomocą łyżki.\n\n6. Przełożenie ciasta do formy:\nPrzełóż masę do formy, wyrównaj powierzchnię.\n\n7. Dekorowanie ciasta:\nNa wierzch ciasta poukładaj plasterki banana i posyp poszatkowaną czekoladą.\n\n8. Pieczenie ciasta:\nPiec przez około 25 minut, aż ciasto będzie sprężyste, a patyczek wbity w środek wyjdzie czysty.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "2 banany",
    "50 g gorzkiej czekolady",
    "3 jajka",
    "3 łyżki mąki owsianej bezglutenowej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "2 łyżki ksylitolu",
    "1 kopiata łyżka kakao"
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-7",
  "name": "Biszkoptowe ciasto z rabarbarem, jabłkami i owsianą kruszonką",
  "category": "CIASTA",
  "shortDesc": "Fenomenalne",
  "fullDesc": "To ciasto to połączenie lekkiego biszkoptu, kwaśnego rabarbaru, słodkich jabłek i chrupiącej owsianej kruszonki. Jest pełne smaku i idealne na każdą okazję, zwłaszcza w sezonie wiosennym, kiedy rabarbar jest w pełni dojrzały. Cudownie łączy smaki i tekstury!",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie ciasta:\nRabarbar umyj i jeśli łodygi są włókniste, obierz je z zewnętrznej warstwy i pokrój w kostkę. Jabłko umyj, obierz ze skórki i usuń gniazdo nasiennne, po czym pokrój w kostkę.\nOddziel białka od żółtek. Białka ubij na sztywną pianę, stopniowo dodając cukier. Dodaj żółtka i zmiksuj na najniższych obrotach. Przesiej mąkę owsianą, mąkę ziemniaczaną i sodę, a następnie dodaj do masy jajecznej. Wymieszaj całość ręcznie.\n\n3. Pieczenie ciasta:\nPrzełóż ciasto do formy, a na wierzch ułóż pokrojone owoce.\n\n4. Przygotowanie kruszonki:\nPłatki owsiane, masło, mąkę kokosową i cukier wymieszaj ręcznie, aż uzyskasz kruszonkę.\n\n5. Wykończenie ciasta:\nKruszonkę wyłóż na owoce.\n\n6. Pieczenie ciasta:\nPiec przez 45 minut w termoobiegu w 180°C.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "Na ciasto:",
    "6 jajek",
    "¾ szklanki mąki owsianej bezglutenowej",
    "3 łyżki mąki ziemniaczanej",
    "5 dużych łodyg rabarbaru",
    "1 duże słodkie jabłko",
    "5 łyżek cukru trzcinowego",
    "½ łyżeczki sody oczyszczonej",
    "Na kruszonkę:",
    "1 i ½ szklanki płatków owsianych bezglutenowych",
    "½ szklanki masła klarowanego w temp. pokojowej",
    "4 łyżki mąki kokosowej",
    "½ szklanki cukru trzcinowego"
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-8",
  "name": "Babka na majonezie",
  "category": "CIASTA",
  "shortDesc": "Babka na majonezie, puszysta i wilgotna.",
  "fullDesc": "Babka na majonezie jest wyjątkowa – wilgotna i puszysta. Majonez dodaje ciastu miękkości, dzięki czemu ciasto nie jest suche, a wręcz rozpływa się w ustach. Idealna na każdą okazję!",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie ciasta:\nJajka ubij na puszysty krem z cukrem lub ksylitolem.\nStopniowo dodawaj przesiane: mąkę uniwersalną mieszankę mąk bezglutenowych, mąkę ziemniaczaną i proszek do pieczenia oraz majonez domowy. Całość dokładnie wymieszaj mikserem na najniższych obrotach.\n\n2. Pieczenie:\nCiasto przelej do wysmarowanej masłem klarowanym i wysypanej mąką uniwersalną mieszanką mąk bezglutenowych blachy (40x9 cm).\nPiekarnik rozgrzej do 190°C.\nPiec przez około 30-35 minut do tzw. suchego patyczka.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "4 jajka",
    "1 szklanka cukru trzcinowego lub ksylitolu",
    "½ szklanki uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½ szklanki mąki ziemniaczanej",
    "2 małe łyżeczki proszku do pieczenia bezglutenowego",
    "5 łyżek domowego majonezu {LINK}",
    "1 łyżka masła klarowanego i 3 łyżki uniwersalnej mieszanki mąk bezglutenowych {LINK}",
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-9",
  "name": "Ciasto z bananem, orzechami i czekoladą",
  "category": "CIASTA",
  "shortDesc": "Ciasto z bananem, orzechami włoskimi i czekoladą",
  "fullDesc": "Ciasto z bananem, orzechami i czekoladą to idealne połączenie słodyczy bananów, chrupiących orzechów i rozpływającej się czekolady. Pyszne i wilgotne ciasto doskonałe na każdą okazję.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Przygotowanie ciasta:\nWszystkie składniki, oprócz trzech bananów, orzechów i czekolady, wrzuć do miski i zblenduj.\n\n2. Dodaj pokrojonego w kostkę banana, orzechy i czekoladę, wymieszaj.\n\n3. Pieczenie:\nCiasto wlej do blachy, udekoruj plasterkami banana. Piecz w piekarniku w termoobiegu przez około 25 minut w temperaturze 200°C.\n\n4. Polewanie czekoladą:\nPo wystudzeniu rozpuść kawałek czekolady i olej w kąpieli wodnej, a następnie polej ciasto.\n\n\n Zdrowego! 🌱✨💚",
  "ingredients": [
    "4 banany (1 banan cały do ciasta, 1 pokrojony w kostkę do ciasta i 2 pokrojone w plasterki do dekoracji",
    "1 jabłko, obrane i oczyszczone z gniazd nasiennych",
    "2 szklanki uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½ szklanki ksylitolu",
    "1 szklanka mleka kokosowego",
    "2 jajka",
    "1 szczypta soli himalajskiej lub innej wysokiej jakości",
    "1 kopiasta łyżeczka sody oczyszczonej",
    "1 łyżeczka proszku do pieczenia bezglutenowego",
    "Garść posiekanych orzechów włoskich",
    "Garść posiekanej gorzkiej czekolady do ciasta",
    "Kawałek gorzkiej czekolady do polania + 1 łyżeczka oleju roślinnego",
  ].join("\n"),
  "path": "ciasta"
},


{
  "id": "ciasto-10",
  "name": "Kakaowe ciasto z soczewicy z bakaliami",
  "category": "CIASTA",
  "shortDesc": "Jak murzynek",
  "fullDesc": "Kakaowe ciasto z soczewicy z bakaliami to zdrowa alternatywa dla tradycyjnych wypieków. Wilgotne, pełne smaku i pełnowartościowe dzięki dodatkom soczewicy, bakalii i orzechów. Idealne na deser lub przekąskę.",
  "image": "Ciasta/ciasto.jpg",
  "preparation": "1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C (termoobieg).\n\n2. Blendowanie składników:\nWszystkie składniki (oprócz orzechów, rodzynek i wiórków kokosowych) wrzuć do miski. Blenduj na gładką masę. Jeśli blender nie poradzi sobie z daktylami, możesz je wcześniej drobno posiekać.\n\n3. Mieszanie dodatków:\nDo masy dodaj posiekane orzechy, rodzynki lub żurawinę. Wymieszaj.\n\n4. Formowanie i dekoracja:\nPrzelej masę do foremki 24cm x 11 cm i posyp wiórkami kokosowymi.\n\n5. Pieczenie:\nPiecz w piekarniku z termoobiegiem przez około 45 minut w temperaturze 180°C.\n\n6. Podawanie:\nPodawaj po wystudzeniu.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "1 i ½ szklanki ugotowanej soczewicy (z czubem)",
    "Opcjonalnie: 1 banan",
    "5 jajek",
    "4 łyżki ksylitolu",
    "Garść suszonych daktyli bez pestek, posiekanych",
    "2 łyżki kakao",
    "½ kopiastej łyżeczki sody oczyszczonej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Garść posiekanych orzechów brazylijskich lub migdałów",
    "Garść rodzynek lub żurawiny",
    "Wiórki kokosowe do posypania"
  ].join("\n"),
  "path": "ciasta"
},



{
  "id": "ciasto-11",
  "name": "Kakaowe ciasto fasolowe",
  "category": "CIASTA",
  "shortDesc": "Smak fasoli nie jest wyczuwalny",
  "fullDesc": "Kakaowe ciasto fasolowe to delikatny i zdrowy deser, idealny dla osób szukających bezglutenowych alternatyw. Dzięki fasoli i bakaliom jest wilgotne i bogate w wartości odżywcze.",
  "image": "Ciasta/ciasto_fasolowe.jpg",
  "preparation": "1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C (termoobieg).\n\n2. Blendowanie składników:\nWszystkie składniki (oprócz orzechów i rodzynek) wrzuć do miski i zblenduj na gładką masę.\n\n3. Mieszanie dodatków:\nWmieszaj posiekane orzechy i rodzynki.\n\n4. Formowanie i dekoracja:\nPrzelej masę do foremki wielkości 24 cm x 11 cm i posyp opcjonalnie płatkami migdałowymi.\n\n5. Pieczenie:\nPiecz w piekarniku przez około 45 minut.\n\n6. Podawanie:\nPodawaj po wystudzeniu.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "2 szklanki ugotowanej czerwonej fasoli",
    "Opcjonalnie: 1 banan, obrany",
    "6 jajek",
    "4 łyżki kakao",
    "6 łyżek ksylitolu",
    "1 łyżeczka sody oczyszczonej",
    "2 płaskie łyżeczki proszku do pieczenia bezglutenowego",
    "Garść posiekanych orzechów",
    "Garść rodzynek",
"Opcjonalnie: Płatki migdałowe, do dekoracji",
  ].join("\n"),
  "path": "ciasta"
},

]

export default Ciasta;
